import { Box, Flex, Grid, Text } from '@chakra-ui/react'
import { Controller } from 'react-hook-form'
import { SelectStyled } from '../../styles'
import { useState } from 'react'
import { format } from 'date-fns'

export const Select = ({ control, ...props }) => {
  const [open, setOpen] = useState(false)

  return (
    <Controller
      control={control}
      name={props.name}
      defaultValue={props.defaultValue}
      render={({ field }) => (
        <SelectStyled
          defaultValue={{ value: field.value, label: field.value }}
          maxMenuHeight={190}
          theme={(theme) => ({
            ...theme,
            spacing: {
              ...theme.spacing,
              controlHeight: 29,
              baseUnit: 2,
            },
          })}
          styles={{
            indicatorSeparator: (provided, state) => ({
              ...provided,
              display: 'none',
            }),

            dropdownIndicator: (base, state) => ({
              ...base,
              transition: 'all .2s ease',
              transform: state.selectProps.menuIsOpen ? 'rotate(180deg)' : null,
              paddingTop: 0,
              paddingBottom: 0,
            }),

            // option: (provided, state) => ({
            //   ...provided,
            // }),
            control: (styles) => ({
              ...styles,
              borderRadius: 0,
              borderColor: props.error ? '#FF0000' : '#CFCFCF',
              '&:hover': { borderColor: '#CFCFCF' },
              //change cor do background do select
              backgroundColor: '#f5f5f5',
              minHeight: 29,
              width: props.width || '309px',
              //mudara cor da seta
            }),

            clearIndicator: (base) => ({
              ...base,
              paddingTop: 0,
              paddingBottom: 0,
            }),

            option: (provided, state) => ({
              ...provided,
              backgroundColor: state.data.isHeader ? '#378BBF' : provided.backgroundColor,
              fontWeight: state.data.isHeader ? 'bold' : 'normal',
              pointerEvents: state.data.isHeader ? 'none' : 'auto',
              cursor: state.data.isHeader ? 'default' : 'pointer',
            }),
          }}
          placeholder={props.placeholder ? props.placeholder : 'Selecione uma opção'}
          onChange={(e) => {
            field.onChange(e.value)
            setOpen(false)
          }}
          value={
            props.options.find((option) => option.value === field.value) ?? {
              value: '',
              label: props.placeholder,
            }
          }
          width={props.name === 'cor' && '700px'}
          options={
            props.name === 'cor'
              ? [{ value: 'header', label: 'Nome | Atualizado | Disponível | Reposição', isHeader: true }, ...props.options]
              : props.options
          }
          getOptionLabel={(option) => {
            const { rgb_cores, label, value, reposicao_estoque, quantidade_reposicao, dt_atualizacao, estoque_disponivel, estoque_dia, isHeader } =
              option

            console.log('props', props)

            if (isHeader) {
              return (
                // <Flex bg="#378BBF" p={2} color="white" fontWeight="bold" fontSize="10px" justifyContent="space-between">
                //   <Text w="245px"></Text>
                //   <Text w="90px">Atualizado</Text>
                //   <Text w="90px">Disponível</Text>
                //   <Text w="80px">Ultra Rápido</Text>
                //   <Text w="90px">Reposição</Text>
                // </Flex>

                <Grid gridTemplateColumns="repeat(5, 1fr)" gap={2} bg="#378BBF" p={2} color="white" fontWeight="bold" fontSize="10px">
                  <Text>Nome</Text>
                  <Text transform="translateX(-6px)">Atualizado</Text>
                  <Text transform="translateX(-4px)">Disponível</Text>
                  <Text>Ultra Rápido</Text>
                  <Text>Reposição</Text>
                </Grid>
              )
            }
            return (
              <Grid gridTemplateColumns={props.name === 'cor' ? 'repeat(5, 1fr)' : '1fr'} gap={2} fontSize="11px">
                <Flex gap={2} w="full" flex={1}>
                  {rgb_cores && (
                    <Box w="20px" h="20px" border="1px solid #cfcfcf" borderRadius="50%" display="flex" alignItems="center" justifyContent="center">
                      <Box w="10px" h="10px" bgColor={rgb_cores} borderRadius="50%" />
                    </Box>
                  )}

                  {label}
                </Flex>
                {props.name === 'cor' && value !== '' && (
                  <>
                    <Text>{dt_atualizacao ? format(new Date(dt_atualizacao), 'dd/MM/yyyy') : 'Sem data'} </Text>
                    <Text>{estoque_disponivel ? estoque_disponivel : 'Sem estoque'}</Text>
                    <Text>{estoque_dia ? estoque_dia : 'Sem estoque'}</Text>
                    <Flex gap={1}>
                      <Text>{reposicao_estoque ? format(new Date(reposicao_estoque), 'dd/MM/yyyy') : ''}</Text>
                      <Text>{quantidade_reposicao ? quantidade_reposicao : '0'} un</Text>
                    </Flex>
                  </>
                )}
              </Grid>
            )
          }}
          onFocus={() => setOpen(true)}
        />
      )}
    />
  )
}
